import ReactMarkdown from "react-markdown";


const Text = ({ textData }) => {
    // Safety check: return null if textData is missing or null
    if (!textData || typeof textData !== 'object') {
        return null;
    }
    
    const { is_full_width } = textData || {}
    const textContent = textData?.text?.text ? textData.text.text : textData.text
    
    if (!textContent) {
        return null;
    }
    
    return (
        <div className={is_full_width ? 'col-sm-12' : 'col-sm-6' }>
            <div className="text">
                <ReactMarkdown children={textContent} />
            </div>
        </div>
    )
}

export default Text
